import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE } from "./motion";

export function AccordionItem({ q, a, testid, dark = false }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border-b ${dark ? "border-white/10" : "border-forest/10"}`}>
      <button
        onClick={() => setOpen(!open)}
        data-testid={testid}
        aria-expanded={open}
        className="group flex w-full items-center justify-between gap-6 py-6 text-left"
      >
        <span className={`font-serif text-xl sm:text-2xl font-medium transition-colors duration-300 ${
          dark ? "text-cream group-hover:text-sage-light" : "text-forest group-hover:text-forest-700"
        }`}>
          {q}
        </span>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
          dark ? "border-white/15 text-sage" : "border-forest/15 text-forest-700"
        }`}>
          <Plus className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: EASE }}
            className="overflow-hidden"
          >
            <p className={`max-w-3xl pb-7 text-sm sm:text-base leading-relaxed ${dark ? "text-cream/65" : "text-charcoal/70"}`}>
              {a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
